import { useEffect, useState } from 'react'
import { RAIL_SLOT_VARIABLE } from '@/shared/theme/railSlot'

const MENU_SLOT_SELECTOR = '[data-menu-slot]'

const useRailSlotSize = (enabled: boolean) => {
  const [menu, setMenu] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (!enabled || !menu) return undefined

    const root = document.documentElement
    const slotObserver = new ResizeObserver(([entry]) => {
      root.style.setProperty(RAIL_SLOT_VARIABLE, `${entry.contentRect.height}px`)
    })
    let slot: Element | null = null
    const followFirstSlot = () => {
      const firstSlot = menu.querySelector(MENU_SLOT_SELECTOR)
      if (firstSlot === slot) return
      if (slot) slotObserver.unobserve(slot)
      slot = firstSlot
      if (slot) slotObserver.observe(slot)
    }
    const entriesObserver = new MutationObserver(followFirstSlot)

    followFirstSlot()
    entriesObserver.observe(menu, { childList: true })

    return () => {
      entriesObserver.disconnect()
      slotObserver.disconnect()
      root.style.removeProperty(RAIL_SLOT_VARIABLE)
    }
  }, [enabled, menu])

  return setMenu
}

export default useRailSlotSize
